import globals from "@/globals";
import translationEnUs from "@/translations/en-us.json";
import translationZhCn from "@/translations/zh-cn.json";
import translationZhTw from "@/translations/zh-tw.json";
import i18next from "i18next";

const i18nResources = {
	"en-US": {
		translation: translationEnUs,
	},
	"zh-CN": {
		translation: translationZhCn,
	},
	"zh-TW": {
		translation: translationZhTw,
	},
};

export async function initI18n(
	lang?: keyof typeof i18nResources,
): Promise<void> {
	if (!lang) {
		if (
			globals.settings.language &&
			i18nResources[
				globals.settings.language as keyof typeof i18nResources
			]
		) {
			lang = globals.settings.language as keyof typeof i18nResources;
		} else if (
			!navigator.language ||
			/^(yue|zh)(-cn|-sg|-hans(-[a-z]+)?)?$/i.test(navigator.language)
		) {
			lang = "zh-CN";
		} else if (
			navigator.language.startsWith("zh") ||
			navigator.language.startsWith("yue")
		) {
			lang = "zh-TW";
		} else {
			lang = "en-US";
		}
	}

	await i18next.init({
		fallbackLng: "en-US",
		interpolation: { escapeValue: false },
		lng: lang,
		resources: i18nResources,
	});
}
